import React from 'react';

const Docx = () => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="32"
      viewBox="0 0 31 32"
    >
      <title>docx</title>
      <path
        fill="#949494"
        d="M22.858 0l7.619 7.619v24.381h-24.381v-5.181l0.761 0.114 0.001 4.305h22.857v-22.857h-7.619v-7.619h-15.238l-0.001 8.876-0.761 0.114v-9.752h16.762zM27.429 26.667v0.762h-12.19v-0.762h12.19zM27.429 24.381v0.762h-12.19v-0.762h12.19zM27.429 22.095v0.762h-12.19v-0.762h12.19zM27.429 19.81v0.762h-12.19v-0.762h12.19zM27.429 17.524v0.762h-12.19v-0.762h12.19zM27.429 15.238v0.762h-12.19v-0.762h12.19zM27.429 12.952v0.762h-12.19v-0.762h12.19zM27.429 10.667v0.762h-12.19v-0.762h12.19zM22.857 1.143v6.476h6.476l-6.476-6.476zM15.238 3.048v0.762h-6.095v-0.762h6.095z"
      ></path>
      <path
        fill="#2b579a"
        d="M15.238 8.381v19.81l-15.238-2.286v-15.238l15.238-2.286zM4.148 14.476h-1.862l1.989 7.619h1.968l1.287-4.888c0.060-0.223 0.106-0.508 0.137-0.855v0h0.021c0.014 0.315 0.054 0.6 0.121 0.855v0l1.256 4.888h1.889l1.999-7.619h-1.72l-1.045 5.085c-0.060 0.287-0.097 0.57-0.111 0.85v0h-0.021c-0.035-0.358-0.076-0.63-0.121-0.818v0l-1.24-5.117h-1.825l-1.372 5.053c-0.088 0.322-0.139 0.62-0.153 0.893v0h-0.032c-0.021-0.365-0.055-0.655-0.1-0.871v0l-1.066-5.074z"
      ></path>
    </svg>
  );
};

export default Docx;
